import React from 'react';
import { includes } from 'lodash';
import { any, bool } from 'prop-types';
import { MediaListener } from '../../utils';

const MobileWrapper = ({ children, condition, showDesktop, hide }) => (
    <MediaListener values={['18%', '100%', '100%']}>
        {({ currentValue }) => {
            const isMobile = includes([currentValue], '100%');
            return (((isMobile && condition) || (!isMobile && showDesktop)) && (!hide || (!isMobile && showDesktop))) && children;
        }}
    </MediaListener>
);

const IsMobileWrapper = ({ children }) => (
    <MediaListener values={['18%', '100%', '100%']}>
        {({ currentValue }) => children({ isMobile: includes(['100%'], currentValue) })}
    </MediaListener>
);

MobileWrapper.propTypes = {
    children: any,
    condition: bool,
    showDesktop: bool,
    hide: bool
};

MobileWrapper.defaultProps = {
    condition: true,
    showDesktop: false,
    hide: false
};

export {
    MobileWrapper,
    IsMobileWrapper
};
